import React from 'react';
import headerUnderline from '../assets/figma/header-underline.svg';
import folderIcon from '../assets/figma/folder.svg';
import cardDivider from '../assets/figma/card-divider.svg';

const projects = [
  {
    date: 'Sept 2026',
    title: 'Github Trending Pipeline',
    description: 'Real-time streaming pipeline using Kafka, AWS EC2, S3, Glue, Athena to ingest and query trending repository metadata.',
    tags: ['Kafka', 'AWS EC2', 'AWS S3', 'Glue', 'Athena', 'Python'],
    href: 'https://github.com/Sipher2003/github-trending-pipeline',
  },
  {
    date: 'Dec 2025',
    title: 'SkillSync - AI Resume Analyzer',
    description: 'AI-powered resume screening and tracking app using Llama LLM, Flask backend, React frontend, and LangChain orchestration.',
    tags: ['AI/ML', 'Llama', 'Flask', 'React', 'LangChain'],
    href: 'https://github.com/Sipher2003/',
  },
  {
    date: 'Apr 2024',
    title: 'Beyond The Pitch - ML Analytics',
    description: 'Machine learning model architecture to predict football player market values, achieving a 97.64% training accuracy.',
    tags: ['ML', 'Flask', 'Streamlit', 'Flutter'],
    href: 'https://github.com/Sipher2003/Beyond-The-Pitch',
  },
];

const Projects = () => (
  <section className="projects-section" id="projects-section">
    <div className="projects-content">
      <header className="projects-header">
        <div className="projects-kicker">
          <span className="projects-kicker-dot" />
          <span>Portfolio Projects</span>
        </div>
        <h2>Featured Work</h2>
        <img className="projects-underline" src={headerUnderline} alt="" aria-hidden="true" />
      </header>

      <div className="projects-cards-row">
        {projects.map((project) => (
          <a className="project-card" href={project.href} target="_blank" rel="noreferrer" key={project.title}>
            <div className="project-card-top">
              <div className="project-header">
                <img className="project-folder-icon" src={folderIcon} alt="" aria-hidden="true" />
                <span className="project-date">{project.date}</span>
              </div>
              <div className="project-title-description">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
            <div className="project-card-footer">
              <img className="project-card-divider" src={cardDivider} alt="" aria-hidden="true" />
              <div className="project-tags">
                {project.tags.map((tag) => <span key={tag}>{tag}</span>)}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
